import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface AuthContextType {
  accessToken: string | null;
  login: (data: { accessToken: string } ) => void;
  logout: () => void;
  agentId: string;
  setAgentId: (id: string) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [agentId, setAgentId] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("accessToken");
    if (storedToken) {
      setAccessToken(storedToken);
    }
  }, []);

  const login = (data: { accessToken: string }) => {
    setAccessToken(data.accessToken);
    localStorage.setItem("accessToken", data.accessToken);
  };

  const logout = () => {
    setAccessToken(null);
    localStorage.removeItem("accessToken");
    navigate("/");
  };
  
  return (
    <AuthContext.Provider value={{ agentId, setAgentId, accessToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
